<section>
  <mat-nav-list>
    <a mat-list-item routerLink="/">
      <mat-icon class="home-icon">home</mat-icon>
    </a>
    <a mat-list-item [routerLink]="['webpage', webpage.slug, webpage.id]"
       *ngFor="let webpage of webpages"> {{ webpage.title }} </a>
    <a mat-list-item [routerLink]="['document', document.slug, document.id]"
       *ngFor="let document of documents"> {{ document.name }} </a>
  </mat-nav-list>
</section>
